const ZoomControl = ({handleZoomOut,currentZoomIndex,zoomLevels,handleZoomIn}) => {
	return (
		<div className="flex items-center bg-white rounded-lg shadow-sm px-2 py-1 space-x-2">
			<button
				onClick={handleZoomOut}
				disabled={currentZoomIndex === zoomLevels.length - 1}
				className={`text-gray-700 p-1 rounded-full transition-colors ${
					currentZoomIndex === zoomLevels.length - 1
						? "opacity-50 cursor-not-allowed"
						: "hover:bg-gray-100"
				}`}
				title="Uzaklaştır"
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					className="h-5 w-5"
					fill="none"
					viewBox="0 0 24 24"
					stroke="currentColor"
				>
					<path
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth={2}
						d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM8 10h4"
					/>
				</svg>
			</button>
			<span className="text-sm text-gray-600 font-medium min-w-[60px] text-center">
				{zoomLevels[currentZoomIndex].label}
			</span>

			<button
				onClick={handleZoomIn}
				disabled={currentZoomIndex === 0}
				className={`text-gray-700 p-1 rounded-full transition-colors ${
					currentZoomIndex === 0
						? "opacity-50 cursor-not-allowed"
						: "hover:bg-gray-100"
				}`}
				title="Yakınlaştır"
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					className="h-5 w-5"
					fill="none"
					viewBox="0 0 24 24"
					stroke="currentColor"
				>
					<path
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth={2}
						d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7"
					/>
				</svg>
			</button>
		</div>
	)
}

export default ZoomControl
